var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _NeuralAmpModelBoxAdapter_context, _NeuralAmpModelBoxAdapter_box;
export class NeuralAmpModelBoxAdapter {
    constructor(context, box) {
        _NeuralAmpModelBoxAdapter_context.set(this, void 0);
        _NeuralAmpModelBoxAdapter_box.set(this, void 0);
        __classPrivateFieldSet(this, _NeuralAmpModelBoxAdapter_context, context, "f");
        __classPrivateFieldSet(this, _NeuralAmpModelBoxAdapter_box, box, "f");
    }
    get box() { return __classPrivateFieldGet(this, _NeuralAmpModelBoxAdapter_box, "f"); }
    get uuid() { return __classPrivateFieldGet(this, _NeuralAmpModelBoxAdapter_box, "f").address.uuid; }
    get address() { return __classPrivateFieldGet(this, _NeuralAmpModelBoxAdapter_box, "f").address; }
    get labelField() { return __classPrivateFieldGet(this, _NeuralAmpModelBoxAdapter_box, "f").label; }
    get modelField() { return __classPrivateFieldGet(this, _NeuralAmpModelBoxAdapter_box, "f").model; }
    getModelJson() {
        return __classPrivateFieldGet(this, _NeuralAmpModelBoxAdapter_box, "f").model.getValue();
    }
    terminate() { }
}
_NeuralAmpModelBoxAdapter_context = new WeakMap(), _NeuralAmpModelBoxAdapter_box = new WeakMap();
